import { JobDescriptionMain } from "../../pages/recruitment/job-description";

const Jobdescription = () => {
	return <JobDescriptionMain />;
};

export default Jobdescription;
